<template>

    <div class="dd-m-graphic dd-m-graphic--line">
        <ul class="dd-m-graphic__list">
            <graphic-line-item v-for="(item, index) in item.values"
                               :key="index"
                               :item="item"></graphic-line-item>
        </ul>
    </div>

</template>
<script>
    import GraphicLineItem from "./graphic-line-item";
    export default {
        name: 'graphic-lines',
        components: {GraphicLineItem},
        props: ['item'],
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/graphics/graphic-lines.vue